<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {holders} from 'src/components/cabinet/#services/user'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import {numberWithSpaces, roundNumber} from 'src/components/#common/helpers'

    let currentPage = 0
    let perPage = 25
    let selectedCurrency = 'LIS'

    function filter() {
        holders.reset()
        holders.send({ data: {
            currency: selectedCurrency,
            page: currentPage + 1,
            perPage,
        }})
        $holders.value
    }

    $:currentPage,perPage,selectedCurrency,filter()
</script>

<svelte:head>
    <title>Top Holders</title>
</svelte:head>

<MainLayout title="Top Holders">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <div class="buttons">
                    <div class="pc-line">
                        <select class="form-select" bind:value={selectedCurrency}>
                            <option>LIS</option>
                            <option>NEAR</option>
                            <option>USDT</option>
                        </select>
                    </div>
                </div>
                {#if $holders.hasValue}
                    <PerPage
                        bind:perPage={perPage}
                        disabled={$holders.loading || $holders.loading}
                        totalCount={$holders.value.totalCount}
                    />
                {/if}
                <div class="transactions-list">
                    <Table bordered striped responsive>
                        <thead>
                        <tr>
                            <td class="text-center">№</td>
                            <td class="text-right">Amount</td>
                            <td class="text-center">User</td>
                        </tr>
                        </thead>
                        <tbody>
                        {#if $holders.loading}
                            {#each {length:perPage} as item}
                                <tr>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                </tr>
                            {/each}
                        {:else if $holders.error || !$holders.hasValue}
                            <tr>
                                <td class="text-center" colspan="3">
                                    {#if $holders.error}
                                        {$holders.error}
                                    {:else}
                                        Something went wrong. Try refreshing the page.
                                    {/if}
                                </td>
                            </tr>
                        {:else}
                            {#each $holders.value.data as {amount, userId, email}, i}
                                <tr>
                                    <td class="text-center">{((currentPage + 1) * perPage) - perPage + i + 1}</td>
                                    <td class="text-right">{numberWithSpaces(roundNumber(+amount))} {$holders.value.currency}</td>
                                    <td class="text-center">
                                        {#if userId}
                                            <a href="profile/{userId}" class="reason" target="_blank" rel="noreferrer">{email}</a>
                                        {/if}
                                    </td>
                                </tr>
                            {:else}
                                <tr>
                                    <td class="text-center" colspan="3">No items</td>
                                </tr>
                            {/each}
                        {/if}
                        </tbody>
                    </Table>
                    {#if $holders.hasValue}
                        <PerPage
                            bind:perPage={perPage}
                            disabled={$holders.loading || $holders.loading}
                            totalCount={$holders.value.totalCount}
                        />
                        <Pagination
                            bind:currentPage={currentPage}
                            totalCount={$holders.value.totalCount}
                            {perPage}
                            disabled={$holders.loading || $holders.loading}
                        />
                    {/if}
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .text-right {
        text-align: right;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .pc-line {
        display: inline-block;
        vertical-align: top;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    @media(max-width: 767px) {
        .pc-line {
            display: block;
        }
    }
</style>
